export default __webpack_public_path__ + "static/grad-3feb1b3172080e8d1080216c669622c5.mp4";